import checkIfBlockIsVisible from "./checkIfBlockIsVisible";

const atLeastOneBlockIsVisible = (blocks = [], context) =>
  blocks.some((block) => checkIfBlockIsVisible(block, context));

const checkIfStepIsVisible = (step, context, preview) => {
  // const { responses } = context;

  if (preview) {
    if (
      !atLeastOneBlockIsVisible(step?.output, context) &&
      !atLeastOneBlockIsVisible(step?.recursiveQuestions, context)
    ) {
      return false;
    }
  } else {
    if (
      !atLeastOneBlockIsVisible(step?.questions, context) &&
      !atLeastOneBlockIsVisible(step?.recursiveQuestions, context)
    ) {
      return false;
    }
  }

  return checkIfBlockIsVisible(step, context);
};

export default checkIfStepIsVisible;
